<script setup lang="ts">

import { useGetAllSessions, createNewSession } from "@/composables/aiChatFunctions"
import { useStore } from "vuex"
import { computed, ref } from "vue"

const emit = defineEmits(['sessionChanged'])
const store = useStore()

const searchAreaDisplayed = ref(false)
const searchTerm = ref('')

const userProfile = computed(() => store.getters['user/userProfile']);
const selectedSession = computed(() => store.getters['ai/selectedSession']);
const { sessions, isLoadingSessions, getSessions } = useGetAllSessions(userProfile.value.uid)

const filteredSessions = computed(() => {
    if (searchTerm.value === '') {
        return sessions.value
    }
    return sessions.value.filter((session) => {
        return session.name.toLowerCase().includes(searchTerm.value.toLowerCase())
    })
})

const handleCreateNewSession = async () => {
    const newSession = await createNewSession(userProfile.value.uid)
    getSessions()
    emit('sessionChanged', newSession)
}

const sessionChanged = (session: any) => {
    emit('sessionChanged', session)
}

</script>

<template>
    <aside class="sidebar">

        <div class="sidebar-container">
            <div v-if="searchAreaDisplayed" class="search-area">
                <input @blur="searchTerm = ''; searchAreaDisplayed = false" v-model="searchTerm" type="text" placeholder="Konuşmalarda Ara" />
            </div>
            <div v-else class="sidebar-actions">
                <img @click="searchAreaDisplayed = !searchAreaDisplayed" class="sidebar-action-icon" src="../../../assets/icons/search.png" alt="Search Chats" />
                <img @click="handleCreateNewSession" class="sidebar-action-icon" src="../../../assets/icons/add.png" alt="Add New Chat" />
            </div>
            <h1 class="chats">Chats</h1>
            <div class="chats-container">
                <ul v-if="!isLoadingSessions">
                    <li @click="sessionChanged(session)" :class="{ 'selected': session.id === selectedSession?.id }" v-for="session in filteredSessions" :key="session.id">
                        {{ session.name }}
                    </li>
                </ul>
            </div>
        </div>
    </aside>
</template>



<style scoped>
.sidebar {
    display: flex;
    justify-content: flex-start;
    height: calc(100svh - 9rem);
    padding: 1.6rem 0 0;
    max-width: 29rem;
    flex-basis: 15%;
    flex-grow: 0;
    color: #f1eeed;
    flex-direction: column;
    background-color: rgb(249, 249, 249);
}

.search-area {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 100%;
    padding: 0 2.4rem;
}

.search-area input {
    width: 100%;
    padding: 1.2rem 2.4rem;
    border-radius: 4px;
    border: 1px solid #000;
    outline: none;
    color: #000;
}

h1.chats{
    font-size: 1.8rem;
    font-weight: 600;
    cursor: pointer;
    margin-top: 1.6rem;
    padding: 0 2.4rem;
    color: #000;
}


.sidebar h2 {
    padding: 1rem 2.4rem;
    cursor: pointer;
}

.sidebar h3 {
    padding: 1rem 2.4rem;
    font-weight: 600;
    font-family: "Roboto", sans-serif;
    font-size: 1.3rem;
    margin-top: 1.6rem;
    text-transform: lowercase;
}

.sidebar-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    height: 100%;
    width: 100%;
}

.chats-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    flex-basis: 100%;
    text-align: center;
    padding: 0 2.4rem;
    margin-top: 1.6rem;
}

.chats-container ul li{
    color: #000;
    font-weight: 400;
    text-align: left;
    font-size: 1.4rem;
    cursor: pointer;
    padding: 1.2rem 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 98%;
}

.chats-container ul li.selected {
    font-weight: 600;
}

.chats-container ul li:hover {
    background-color: #f1eeed;
    border-radius: 4px;
}
.sidebar-actions {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    gap: 1.4rem;
    width: 100%;
    padding: 0 2.4rem;
}

.sidebar-action-icon {
    width: 1.8rem;
    height: 1.8rem;
    cursor: pointer;
    filter: brightness(0);
}

@media screen and (max-width: 900px) {

    .sidebar h3:first-of-type {
        margin-top: 0;
    }
}
</style>